// @ts-nocheck
import {
    chain,
    SetShipToForEditing,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetUseOneTimeAddress";
import { getAllowedCountries } from "@store/Framework/Store/Data/Countries/CountriesSelectors";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, SetShipToForEditing, props => {
    if (props.parameter.useOneTimeAddress) {
        const countries = getAllowedCountries(props.getState());
        props.shipToForEditing.country = countries?.length === 1 ? countries[0] : null;
    }
});
